import * as React from "react";
import { createFragmentContainer } from "react-relay";
import withStyles from "@material-ui/core/styles/withStyles";
import { Fab } from "@material-ui/core";
import { Save } from "@material-ui/icons";

// components
import { DraggableWorkingHours } from "@components/draggable-working-hours";

// util
import { workingHoursAsInput } from "@util/working-hours.util";
import { getCurrentOrg } from "@util/org.util";

// mutations
import { updateWorkingHours } from "@mutations";

// routing
import { withRouteQuery } from "@routing/routes.util";

// internal
import { IProps, IState } from "./WebAppWorkingHours.d";
import { webAppWorkingHoursFragments, webAppWorkingHoursQuery } from "./WebAppWorkingHours.gql";
import { styles } from "./WebAppWorkingHours.styles";

///////////////
// Component //
///////////////

class WebAppWorkingHoursComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isDirty: false,
    };
  }

  private save = () => {
    updateWorkingHours(
      this.props.relay.environment,
      {
        workingHours: workingHoursAsInput(this.state.updatedWorkingHours!),
        saveMeetingAndWorkingHours: true,
      },
      () => this.setState({ isDirty: false }),
      () => null,
    );
  };

  public render() {
    const { classes, viewer } = this.props;

    const org = getCurrentOrg(viewer);

    if (!org || !org.userWorkingHours.workingHours) {
      return null;
    }

    return (
      <div className={classes.wrappingContainer}>
        <DraggableWorkingHours
          enableSplitHours
          onChange={(workingHours) =>
            this.setState({ updatedWorkingHours: workingHours, isDirty: true })
          }
          workingHours={org.userWorkingHours.workingHours}
        />
        {this.state.isDirty && this.state.updatedWorkingHours ? (
          <Fab color="primary" className={classes.fab} onClick={this.save}>
            <Save />
          </Fab>
        ) : null}
      </div>
    );
  }
}

/////////////////
// With Styles //
/////////////////

const WebAppWorkingHoursStyled = withStyles(styles)(WebAppWorkingHoursComponent);

///////////
// Relay //
///////////

export const WebAppWorkingHours = createFragmentContainer(
  WebAppWorkingHoursStyled,
  webAppWorkingHoursFragments,
);

export const WebAppWorkingHoursPage = withRouteQuery(WebAppWorkingHours, webAppWorkingHoursQuery);
